module.exports = __webpack_public_path__ + "img/logo_w.51cee888.svg";